import { Typography } from '@mui/material'
import React from 'react'

const FooterTitle = ({ text }) => {
  return (
    <Typography
    variant='h4'
    component='h4'
    sx={{
      fontWeight: '700',
      textTransform: 'uppercase',
      pb: 1,
      color: '#0deb2a',
      '@media (max-width:420px)': {
        fontSize: '9vw',
       
      },
    }}
    >
      { text }
    </Typography>
  )
}

export default FooterTitle